@if (!isStreamView) {
    <ion-header>
        <ion-toolbar  class="{{themeService.isDarkMode ? 'dark': 'light'}}">
            <div class="toolbar {{startMatch?.matchStatus === 'IN_PROGRESS' ? '' : tie && tie?.matchStatus === 'TBP' && tie?.startDate ? 'has-date' : ''}}">
                <div class="left-side">
                    <ion-buttons slot="start" mode="md">
                        <ion-back-button [defaultHref]="defaultBackHref"></ion-back-button>
                    </ion-buttons>
                </div>
                <div class="center-side">
                    @if(tie?.discipline === "TENNIS"){
                        @if(startMatch?.matchStatus === "IN_PROGRESS"){
                            <ion-segment value="all" mode="md">
                                <div class="center-info">
                                    <div class="team">
                                        @if(tie.winningSide === 1 && tie?.matchStatus === "COMPLETED"){
                                            <ion-icon class="icon win-checkmark" color="dark" name="checkmark"></ion-icon>
                                        }
                                        <div class="abbreviation">
                                        {{ getAccronym(1) }}
                                        </div>
                                    </div>

                                    <div class="score" [ngClass]="{ 'small': isScoreSmall(tie?.score) }">
                                    {{ tie?.score }}
                                    </div>

                                    <div class="team">
                                        @if(tie.winningSide === 2 && tie?.matchStatus === "COMPLETED"){
                                            <ion-icon class="icon win-checkmark" color="dark" name="checkmark"></ion-icon>
                                        }
                                        <div class="abbreviation">
                                        {{ getAccronym(2) }}
                                        </div>
                                    </div>
                                </div>
                            </ion-segment>
                        } @else{
                            @if(tie && tie?.matchStatus !== "TBP"){
                                <ion-segment value="all" mode="md">
                                    <div class="center-info">
                                        <div class="team">
                                            @if(tie.winningSide === 1 && tie?.matchStatus === "COMPLETED"){
                                                <ion-icon class="icon win-checkmark" color="dark" name="checkmark"></ion-icon>
                                            }
                                            <div class="abbreviation">
                                            {{ getAccronym(1) }}
                                            </div>
                                        </div>

                                        <div class="score" [ngClass]="{ 'small': isScoreSmall(tie?.score) }">
                                        {{ tie?.score }}
                                        </div>

                                        <div class="team">
                                            @if(tie.winningSide === 2 && tie?.matchStatus === "COMPLETED"){
                                                <ion-icon class="icon win-checkmark" color="dark" name="checkmark"></ion-icon>
                                            }
                                            <div class="abbreviation">
                                            {{ getAccronym(2) }}
                                            </div>
                                        </div>
                                    </div>
                                </ion-segment>
                                }

                            @if(tie && tie?.matchStatus === "TBP"){
                                <div class="tie-start-date">
                                    {{ tie?.startDate | date : "EEEE, MMMM d, y, h:mm a" }}
                                </div>
                            }
                        }
                    }
                </div>
                <div class="right-side">
                    @if (authService.authUserSignal()) {
                        @if (tie) {
                        <ion-buttons slot="end" class="follow-tie" mode="md">
                            <app-follow-tie
                              [_tieId]="tie._id"
                              [tieViewers]="tie.viewers"
                            >
                            </app-follow-tie>
                        </ion-buttons>
                        }
                    }
                    <ion-buttons slot="end" class="share-button" mode="md">
                        <app-share-match [tieId]="tie?._id" [position]="'header'"></app-share-match>
                        @if (!authService.authUserSignal()) {
                            <app-login-modal (isAuthenticated)="isAuthenticated()"></app-login-modal>
                        }
                    </ion-buttons>
                </div>
            </div>
        </ion-toolbar>
    </ion-header>
}

<ion-content class="{{themeService.isDarkMode ? 'dark': 'light'}}">
    <ion-refresher (ionRefresh)="getTie($event)" slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    @if (!isLoading) {       
        <div class="scoreboard-margin">
            <app-tie-scorecard [tie]="tie" [numberOfViewers]="numberOfViewers" [isOwner]="isOwner()" [isOfficial]="isOfficial" (openMenu)="presentPopover()"></app-tie-scorecard>
        </div>

        @if (areCollectionDefinitionsAvailable()) {
            @if (!isUpdatingLineup) {
                <app-tie-match-list [tie]="tie" #tieMatchList></app-tie-match-list>
            }
        } @else {
            @if (isOwner() || isTracker) {
                <div class="ion-text-center" style="margin-top: 100px;">
                    @if (!isAddingTemplate) {
                        <app-add-template (selectedSubtype)="addFromTemplate($event)" type="button"></app-add-template>
                    } @else {
                        <ion-spinner name="crescent"></ion-spinner>
                    }

                    <br />
                    <ion-button (click)="addCollection()" fill="clear">
                        {{ 'Build team match' | translate }}
                    </ion-button>
                </div>
            }
        }

        @if (!isStreamView && authService.authUserSignal()?.role?.value > 399) {
            <div class="content-width">
                <div class="ion-padding-start ion-padding-end">
                    <ion-button (click)="addTieOwner()" expand="block">
                        {{'Add owner' | translate}}
                    </ion-button>

                    <ion-button color="danger" (click)="removeTieOwner()" expand="block">
                        {{'Remove owner' | translate}}
                    </ion-button>
                </div>
            </div>
        }
    } @else {
        <app-empty-page text="{{'There are no matches' | translate}}" iconName="tennisball"></app-empty-page>
    }

</ion-content>

@if (!isStreamView && !isLoading && tie?.matchStatus !== 'TBP') {
    <ion-footer>
        <ion-toolbar>
            <ion-item lines="none">
                <ion-toggle [checked]="isLiveMatchesOnly" (ionChange)="filterMatches()">{{ 'Live matches' | translate }}</ion-toggle>
            </ion-item>
        </ion-toolbar>
    </ion-footer>
}